import PaisService from "../../services/PaisService";
import FormSelectSearchModal from "../forms/base/FormSelectSearchModal";
import FormPais from "../../pages/Pais/FormPais";
import Permissao from "../../controllers/Permissao";

export default class SelectPais extends FormSelectSearchModal {

    constructor(props) {
        super(props);
        this.getOptions = this.getOptions.bind(this);

        this.state.showBtns = this.props.showBtns === undefined ? true : this.props.showBtns;
        this.state.showBtnSearch = this.state.showBtns && (this.props.showBtnSearch === undefined ? true : false);
        this.state.showBtnNewForm = this.state.showBtns && ((this.props.showBtnNewForm === undefined ? true : false) && Permissao.getInstance().getPermissao(4));
        this.state.showBtnNewSearch = this.state.showBtns && (this.props.showBtnSearch === undefined ? true : false);
    }

    getConfigFormNew() {
        return {
            title: 'Cadastro de País',
            sizeModal: 'modal-xl',
            config: {
                isModal: true
            },
            form: FormPais,
            onSave: (response) => {
                this.getOptions(() => {
                    if (response.data?.idPais) {
                        this.handleOpenSearch(null, response.data?.idPais);
                    } else {
                        this.handleOpenSearch();
                    }
                });
            },
            onClose: () => {
                //this.handleOpenSearch();
            }
        };
    };

    componentDidMount() {
        super.componentDidMount();
        this.getOptions(() => {
            if (this.dispachChangeDidMount && this.props.value) {
                this.handleChange({ target: { value: this.props.value, name: this.props.name } });
            }
        });
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getOptions(callBack) {
        PaisService.getForCombo((response) => {
            this.setState({ options: response }, () => {
                if (callBack) {
                    callBack();
                }
            });
        });
    }

    render() {
        return super.render();
    }
}